module.exports = __webpack_public_path__ + "static/icon-sales-cfbef10cdce3e265e2c0fe88056ee6f1.svg";